import { useEffect } from 'react';

/**
 * Hook to handle clicks outside of a specified element
 * @param isOpen - Whether the dropdown/modal is open
 * @param className - The className to check for (e.g., 'timeframe-dropdown')
 * @param onClose - Callback to call when clicking outside
 */
export const useClickOutside = (isOpen: boolean, className: string, onClose: () => void) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (!target.closest(`.${className}`)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, className, onClose]);
};

